import type { HTMLProps } from "react"
import styles from "./YAxisSeparator.module.scss"

const strokeWidth = 0.5

export function YAxisSeparator(props: HTMLProps<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={styles.container}
    >
      <svg className={styles.svg}>
        <line
          className={styles.line}
          strokeLinecap="round"
          strokeWidth={strokeWidth}
          x1={strokeWidth / 2}
          y1="0"
          x2={strokeWidth / 2}
          y2="100%"
        />
      </svg>
    </div>
  )
}
